import { createContext } from "react";

export const AuthContext = createContext({
    isLoggedIn: false,
    token: null,
    userId: null,
    user: null,
    login: () => {},
    logout: () => {},
    selectedProject: null,
    setSelectedProject: () => {},
    selectedScenario: null,
    setSelectedScenario: () => {}
});
